import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { courseService } from '../services/apiService'
import CourseCard from '../components/CourseCard'

const MyCourses = () => {
  const { user } = useContext(AuthContext)
  const [courses, setCourses] = useState([])
  const [enrollments, setEnrollments] = useState([])
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState('enrolled')

  useEffect(() => {
    if (user?.role === 'instructor') {
      fetchMyCourses()
    }
    fetchEnrollments()
  }, [user])

  const fetchMyCourses = async () => {
    try {
      const response = await courseService.getMyCourses()
      const data = response.data.results || response.data
      setCourses(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Error fetching my courses:', error)
      setCourses([])
    } finally {
      setLoading(false)
    }
  }

  const fetchEnrollments = async () => {
    try {
      const response = await courseService.getEnrollments()
      const data = response.data.results || response.data
      setEnrollments(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Error fetching enrollments:', error)
      setEnrollments([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'>
      <div className='flex items-center justify-between mb-8'>
        <h1 className='text-3xl font-bold text-gray-900'>My Courses</h1>
        {user?.role === 'instructor' && (
          <Link
            to='/create-course'
            className='bg-primary-600 text-white px-6 py-2 rounded-md hover:bg-primary-700 font-medium'
          >
            + Create Course
          </Link>
        )}
      </div>

      {user?.role === 'instructor' && (
        <div className='mb-6 border-b border-gray-200'>
          <nav className='-mb-px flex space-x-8'>
            <button
              onClick={() => setActiveTab('enrolled')}
              className={`${
                activeTab === 'enrolled'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            >
              Enrolled Courses
            </button>
            <button
              onClick={() => setActiveTab('teaching')}
              className={`${
                activeTab === 'teaching'
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
            >
              My Created Courses
            </button>
          </nav>
        </div>
      )}

      {loading ? (
        <div className='text-center py-12'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto'></div>
        </div>
      ) : (
        <>
          {activeTab === 'enrolled' && (
            <div>
              {enrollments.length > 0 ? (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                  {enrollments.map((enrollment) => (
                    <CourseCard
                      key={enrollment.id}
                      course={enrollment.course}
                    />
                  ))}
                </div>
              ) : (
                <div className='text-center py-12'>
                  <p className='text-gray-500'>
                    You haven't enrolled in any courses yet.
                  </p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'teaching' && user?.role === 'instructor' && (
            <div>
              {courses.length > 0 ? (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                  {courses.map((course) => (
                    <CourseCard key={course.id} course={course} />
                  ))}
                </div>
              ) : (
                <div className='text-center py-12'>
                  <svg
                    className='mx-auto h-12 w-12 text-gray-400 mb-4'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
                    />
                  </svg>
                  <p className='text-gray-500 mb-4'>
                    You haven't created any courses yet.
                  </p>
                  <Link
                    to='/create-course'
                    className='inline-block bg-primary-600 text-white px-6 py-2 rounded-md hover:bg-primary-700 font-medium'
                  >
                    Create Your First Course
                  </Link>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default MyCourses
